import React from 'react'
import { Radio, RadioGroup } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { SCREENING_TAG } from '../util/artifactsConstants'

export default function RestrictArtifactsDialogOverlay({ pendingScreeningTag, setPendingScreeningTag }) {
  const { t } = useTranslation()
  const screeningTagRadioOnChange = (e) => {
    setPendingScreeningTag(e.target.value)
  }

  return (
    <RadioGroup label={t('artifacts.selectRestrictionReason', 'Select reason for restriction:')}>
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.IMMODESTY', 'Immodesty')}
        value={SCREENING_TAG.IMMODESTY}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.IMMODESTY}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.PORN', 'Pornography')}
        value={SCREENING_TAG.PORN}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.PORN}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.VIOLENCE_HATE', 'Violence/Hate')}
        value={SCREENING_TAG.VIOLENCE_HATE}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.VIOLENCE_HATE}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.KISSING', 'Kissing')}
        value={SCREENING_TAG.KISSING}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.KISSING}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.SACRED_CONTENT', 'Sacred Content')}
        value={SCREENING_TAG.SACRED_CONTENT}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.SACRED_CONTENT}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.URLS', 'URLs')}
        value={SCREENING_TAG.URLS}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.URLS}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.INAPPROPRIATE_CONTENT', 'Inappropriate Content')}
        value={SCREENING_TAG.INAPPROPRIATE_CONTENT}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.INAPPROPRIATE_CONTENT}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.ORDINANCES', 'Ordinances')}
        value={SCREENING_TAG.ORDINANCES}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.ORDINANCES}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.LIVING_REQUEST', 'Living Request')}
        value={SCREENING_TAG.LIVING_REQUEST}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.LIVING_REQUEST}
      />
      <Radio
        name="screeningTag"
        label={t('artifact.screeningTag.COPYRIGHT', 'Copyright')}
        value={SCREENING_TAG.COPYRIGHT}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.COPYRIGHT}
      />
      <Radio
        name="screeningTag"
        label={t('other', 'Other')}
        value={SCREENING_TAG.OTHER}
        onChange={screeningTagRadioOnChange}
        checked={pendingScreeningTag === SCREENING_TAG.OTHER}
      />
    </RadioGroup>
  )
}
